import router from '@/router'

export const processErrorMessages = error => {
  let title = error.response.data.message || error.response.statusText
  let text = ''
  let html = ''
  let showAlert = false

  if (error.response && error.response.status == 403) {
    title = error.response.data.message

    showAlert = true
    // router.push({ name: '403' })
  }

  if (error.response && error.response.status == 422) {
    title = error.response.data.message
    const errors = error.response.data.errors

    Object.keys(errors).forEach(key => {
      html += errors[key] + '<br />'
    })

    showAlert = true
  }

  if (error.response && error.response.status == 404) {
    // router.push({ name: '404' })
  }

  if (error.response && error.response.status == 403) {
    title = error.response.data.message

    showAlert = true
    // router.push({ name: '403' })
  }

  if (
    error.response &&
    error.response.status == 401
  ) {
    if (error.response.data.message !== 'Invalid credentials.') {
      router.push({ name: 'login' }) // TODO - add current page as params for redirect
    } else {
      title = error.response.data.message

      showAlert = true
    }  
  }

  return {
    showAlert,
    alertOptions: {
      title,
      text,
      html
    }
  }
}
